/**
 * All the configuration related to localization
 * @type {[*]}
 */
export const supportedLanguages = ["en", "pt"];

